// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CanarySeparatorTsx from "./CanarySeparator.tsx";

let make = CanarySeparatorTsx.CanarySeparator;

export {
  make,
}
/* make Not a pure module */
